import { render } from "./PartnerCarDetails.vue?vue&type=template&id=6e682165&scoped=true&ts=true"
import script from "./PartnerCarDetails.vue?vue&type=script&lang=ts"
export * from "./PartnerCarDetails.vue?vue&type=script&lang=ts"

import "./PartnerCarDetails.vue?vue&type=style&index=0&id=6e682165&scoped=true&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e682165"]])

export default __exports__